export default "__VITE_ASSET__DF$dU_VH__"